import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmployerService } from '../../../services/modules/employer.service';
import { formatStatusDate, PayrollPersonHistoryItem, resolveHistoryBadge, ReviewHistoryEntry } from '../../../helpers/prenomina.helper';

export interface PrenominaHistorialMovement {
  label: string;
  cssClass: string;
  comment: string;
  date: string;
  userName: string;
}

export interface DialogPrenominaHistorialData {
  payrollPersonId: number;
  personalName?: string;
  history?: ReviewHistoryEntry[];
  /** Estado actual de la fila; se muestra si el historial no se puede cargar. */
  current: PrenominaHistorialMovement;
}

@Component({
  selector: 'app-dialog-prenomina-historial',
  templateUrl: './dialog-prenomina-historial.component.html',
  styleUrls: ['./dialog-prenomina-historial.component.scss']
})
export class DialogPrenominaHistorialComponent implements OnInit {
  loading = true;
  historyUnavailable = false;
  movements: PrenominaHistorialMovement[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogPrenominaHistorialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogPrenominaHistorialData,
    private employerService: EmployerService
  ) { }

  ngOnInit(): void {
    // El historial de revisión es entregado directamente por la API dentro de cada fila de la minuta (ReviewHistory).
    const rawHistory = this.data.history || [];

    if (rawHistory.length > 0) {
      this.movements = rawHistory
        .slice()
        .sort((a, b) => {
          const dateA = a.Date || a.UpdateDate || '';
          const dateB = b.Date || b.UpdateDate || '';
          return dateB.localeCompare(dateA);
        })
        .map(item => this.toMovement(item));
      this.loading = false;
      return;
    }

    // Si la fila no cuenta con movimientos en ReviewHistory (por ejemplo, registros anteriores a la
    // auditoría del backend), pero ya tiene un estado asignado (Aprobado, Revisado, Rechazado),
    // mostramos su estado actual en la línea de tiempo para presentar la información del registro.
    if (this.data.current && this.data.current.label && this.data.current.label !== 'Sin revisar') {
      this.movements = [this.data.current];
    } else {
      this.movements = [];
    }

    this.loading = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  private toMovement(item: ReviewHistoryEntry | PayrollPersonHistoryItem | any): PrenominaHistorialMovement {
    const statusVal = item.StatusValue || item.ReviewStatusValue || null;
    const actionVal = item.Action || null;
    const descVal = item.StatusDescription || item.ReviewStatusDescription || null;
    const badge = resolveHistoryBadge(statusVal, actionVal, descVal);
    const dateVal = item.Date || item.UpdateDate;
    return {
      label: descVal || badge.label,
      cssClass: badge.cssClass,
      comment: item.Comment || '',
      date: formatStatusDate(dateVal),
      userName: item.UserName || ''
    };
  }
}
